<template>
  <v-row no-gutters>
    <!-- CREAR COMPUTADA QUE ORDENE SEGUN CAMPO ORDEN-->

    <v-col
      v-for="item in dsCaracteristicas.ttinmaecar"
      :key="item.Codigo"
      cols="12"
      sm="6"
      md="6"
    >
      <v-card :class="['mx-0 ma-3']" max-width="550" flat>
        <v-row
          align="start"
          no-gutters
          :justify="$vuetify.breakpoint.mdAndDown ? 'center' : 'start'"
        >
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 6 : 4">
            <v-list-item three-line>
              <v-img
                aspect-ratio="1.1"
                contain
                v-if="item.Imagen != ''"
                :src="`${imgFT}${item.Imagen}`"
                @click="itemImg(item.Codigo)"
                style="cursor: pointer"
                :class="['pa-3']"
                :max-width="$vuetify.breakpoint.mdAndDown ? 220 : 140"
                ><template v-slot:placeholder>
                  <v-row class="fill-height ma-0">
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="8">
            <v-card-text class="body-1 font-weight-bold black--text"
              >{{ item.Titulo }}
            </v-card-text>
            <v-card-subtitle class="mt-n6">
              {{ item.Contenido }}
            </v-card-subtitle>
            <v-card-actions>
              <v-btn
                elevation="2"
                color="accent"
                small
                target="_blank"
                :href="`https://${item.LinkTextoAmp}`"
                dark
                v-if="item.LinkTextoAmp"
                >Ver mas</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-row>
        <v-card-actions
          v-if="dataUser.IndAutenticado && dataUser.IndMantGaleria"
        >
          <v-spacer></v-spacer>

          <v-row no-gutters
            ><v-spacer></v-spacer>
            <v-col cols="12" offset-md="5">
              <v-btn icon  @click="DelFetureDialog(item.Codigo)"
                >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="28" color="error" v-bind="attrs" v-on="on"
                      >mdi-playlist-remove</v-icon
                    >
                  </template>
                  <span>Eliminar Caracteristica</span>
                </v-tooltip>
              </v-btn>
               <strong class="error--text text--lighten-2" v-if="deleteConfirm && idDel===item.Codigo">
                {{ `${deleteConfirm ? `Seguro de Eliminar?` : ``}` }}
                </strong>
          

          
              <v-card
                class="d-flex mx-auto"
                v-if="deleteConfirm && idDel===item.Codigo"
                flat
                tile
              >
                <v-btn 
                small 
                plain 
                fab 
                color="primary" 
                class="mt-n1 ml-3" 
                @click="OffAsingFeature(codArt, item.Codigo)">
                  Si
                </v-btn>

                <v-btn
                  small
                  class="mt-n1"
                  fab
                  plain
                  color="error"
                  @click="DelFetureDialog"
                >
                  No
                </v-btn>
              </v-card>
              
            </v-col>
          </v-row>
         
        </v-card-actions>
      </v-card>
    </v-col>
    <vue-easy-lightbox
      escEnabled
      moveEnabled
      :visible="visible"
      :imgs="imgs"
      @hide="handleHide"
    >
    </vue-easy-lightbox>
  </v-row>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import InnerImageZoom from "vue-inner-image-zoom";

export default {
  data() {
    return {
      visible: false,
      imgs: "",
      index: 0,
      deleteConfirm: false,
      idDel:null
    };
  },
  components: {
    InnerImageZoom,
  },
  methods: {
    ...mapActions(["cargarFeature"]),
    DelFetureDialog(item) {
      this.idDel= item
      this.deleteConfirm = !this.deleteConfirm;
    },
    async OffAsingFeature(codart, idFeatu) {
      this.deleteConfirm = false
      if (this.idCia) {
        await this.cargarFeature({
          codigo: idFeatu,
          articulo: codart,
          opc: 6,
          cia: this.idCia,
        });
        this.$nextTick(function() {
          this.cargarFeature({
            articulo: codart,
            cia: this.idCia,
             status: 1,
            opc: 8,
          });
        });
      }

      /*
      await this.cargarFeature({
        codigo: idFeatu,
        articulo: codart,
        opc: 6,
        cia: this.idCia,
      });
      this.$nextTick(function() {
        this.isAsingFeture(this.editedItem); // => 'updated'
         this.cargarFeature({
          articulo:codart,
          cia: this.idCia,
          opc: 8,
        });
      });

      */
    },
    itemImg(id) {
      if (this.dsCaracteristicas) {
        let nb = this.dsCaracteristicas.ttinmaecar
          .filter((x) => x.Codigo === id)
          .map((x) => x.Imagen);
        this.imgs = this.imgFT + nb.toString();
      }

      this.show();
    },

    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },

  computed: {
    ...mapState([
      "Articulo",
      "imgFT",
      "dsCaracteristicas",
      "dataUser",
      "maestro",
    ]),
    idCia() {
      if (this.maestro.ttDivision) {
        let nb = this.maestro.ttDivision.map((x) => x.Cia).toString();
        return nb;
      }
    },
    codArt() {
      if (this.Articulo) {
        let nb = this.Articulo.map((x) => x.Codigo).toString();
        return nb;
      }
    },
  },
};
</script>

<style></style>
